import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Form } from "../../models/app-state";
import { UntypedFormGroup } from "@angular/forms";
import { Campo } from "../../models/coleta";
import { ActivatedRoute } from "@angular/router";
import { AppFlowService } from "../../services/app-flow.service";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { take } from 'rxjs/operators';

@Component({
  selector: "app-dependencies-group",
  templateUrl: "./dependencies-group.component.html",
  styleUrls: ["./dependencies-group.component.scss"],
})
export class DependenciesGroupComponent implements OnInit, OnDestroy {
  hasDependencies = false;
  dependencies: Campo[] | undefined = [];
  internalCampo: Campo = {};
  fieldValue = "";

  @Input()
  form!: Form;

  @Input()
  formGroup!: UntypedFormGroup;

  @Input()
  set campo(campo: Campo) {
    this.internalCampo = campo;
    this.hasDependencies = !!campo.dependentes?.length;
  }

  get campo(): Campo {
    return this.internalCampo;
  }

  constructor(
    private actRoute: ActivatedRoute,
    private appFlowService: AppFlowService,
    private dbService: NgxIndexedDBService
  ) {}

  /*
  A function abaixo trata os campos dependentes que sao ocultos.
  Para isso, valida se o campo PAI possui o valor esperado igual a X valor. Ex: True, caso o campo seja uma checkbox.
  Em seguida, coloca o campo dependente como obrigatório e remove o atributo de OCULTO.
  O dependente é renderizado neste componente, que é diferente do componente do campo pai.

  Este componente nao estava tratando dependencias de campos aparentes (nao ocultos).
  Como o campo pai é renderizado em outro componente, esta function foi implementada 
  no dynamic-input.component (handleCamposPaisDependencies).
  */
  handleDependencies(value: string): void {
    this.fieldValue = value;
    this.removeNonDependencies();
    const allFields = this.appFlowService.getAppState().fieldsAsObject;

    const dependencies = this.campo?.dependentes
      ?.filter((el) => el.valorEsperado === value)
      ?.map((el) => {
        this.formGroup.removeControl(el.campoDependenteCodigo);

        const field = allFields[el.campoDependenteCodigo];
       
        if (el.acao === "OBRIGAR") {
          try {
            field.atributos?.push({
            id: 17,
            propriedade: "OBRIGATORIEDADE",
            configuracao: "comum",
            valor: "true",
            });
          } catch(error){
            console.log(error)
          }
        }
        
        return field;
      });

      try {
          dependencies?.forEach((el) => {
          el.atributos?.find((item) => {
            if (item && item.propriedade === "OCULTO") {
              item.valor = "false";
            }
          });
        });
      } catch(error){
        console.log(error)
      }
    this.dependencies = dependencies;
  }

  /*
  A function abaixo busca todos os campos dependentes filhos ocultos,
  cujo o campo pai nao está com o valor esperado e remove-os do formulario.

  Exemplo:
  Quando escolhemos um tipo de documento, temos 15 campos ocultos (rg, cnh, etc)
  Quand o campo pai está marcado como RG, a function abaixo irá remover todos os outros
  tipos de documentos do formulário do angular.

  Adicionada tratativa para nao considerar campos que nao possuem a propriedade oculto.
  Está sendo tratado no método handleCamposPaisDependencies do componente dynamic-input.
  */
  removeNonDependencies(): void {
    let allShowingFields: Campo[] = Object.values(
      this.appFlowService.getAppState().fieldsAsObject
    ).filter((campo) => !campo.atributos?.find(atributo => atributo.propriedade === "OCULTO"));

    const dependencies = this.campo?.dependentes
      ?.filter((el) => el.valorEsperado === this.fieldValue)
      .map((el) => el.campoDependenteCodigo);

    const dependenciesToBeRemoved = this.campo?.dependentes
      ?.filter((el) => !dependencies?.includes(el.campoDependenteCodigo) && !allShowingFields.find(campo => campo.codigo === el.campoDependenteCodigo))
      ?.map((el) => el.campoDependenteCodigo);

    if (this.campo?.codigo) {
      dependenciesToBeRemoved?.forEach((el) => {
        this.formGroup.removeControl(el);
        
        this.dbService.delete("images", el).pipe(take(1)).subscribe();
      });
    }
  }

  ngOnInit(): void {
    if (this.campo?.codigo) {
      this.handleDependencies(this.formGroup.value[this.campo.codigo]);
      this.formGroup.controls[this.campo.codigo].valueChanges.subscribe((el) =>
        this.handleDependencies(el)
      );
    }
  }

  ngOnDestroy(): void {
    this.removeNonDependencies();
  }
}
